// extracted by mini-css-extract-plugin
module.exports = {"error":"sqITy7","text":"lZZlDZ"};